import LocalImage from "@/components/image/LocalImage";

//#region [Props]
type CloseProps = {
    className?: string;
    alt?: string;
    theme?: "light" | "dark";
};
//#endregion

//#region [Component]
export default function Close({ className, alt, theme = "light" }: CloseProps) {
    return theme === "light" ? <LocalImage className={className} src="/Close.svg" alt={alt ?? "Lukk"} width={20} height={20} /> : <LocalImage className={className} src="/CloseDark.svg" alt={alt ?? "Lukk"} width={20} height={20} />;
}
//#endregion

//#region [Styles]

//#endregion